module.exports = __webpack_public_path__ + "img/D_Read_more_pregnancy.8a769466.svg";